import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVehicles = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M47.5 42.5H52.5C54 42.5 55 41.5 55 40V32.5C55 30.25 53.25 28.25 51.25 27.75C46.75 26.5 40 25 40 25C40 25 36.75 21.5 34.5 19.25C33.25 18.25 31.75 17.5 30 17.5H12.5C11 17.5 9.75 18.5 9 19.75L5.5 27C5.16895 27.9656 5 28.9793 5 30V40C5 41.5 6 42.5 7.5 42.5H12.5M47.5 42.5C47.5 45.2614 45.2614 47.5 42.5 47.5C39.7386 47.5 37.5 45.2614 37.5 42.5M47.5 42.5C47.5 39.7386 45.2614 37.5 42.5 37.5C39.7386 37.5 37.5 39.7386 37.5 42.5M12.5 42.5C12.5 45.2614 14.7386 47.5 17.5 47.5C20.2614 47.5 22.5 45.2614 22.5 42.5M12.5 42.5C12.5 39.7386 14.7386 37.5 17.5 37.5C20.2614 37.5 22.5 39.7386 22.5 42.5M22.5 42.5H37.5",
		stroke: "#0A3C93",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgVehicles;
